import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { Planner } from '@teetsh/app/src/types/planner';
import { PLANNER_KEY } from './usePlanner';

interface Props {
  plannerId: string;
}

export default function useUpdatePlanner(props: Props) {
  const { plannerId } = props;
  const queryClient = useQueryClient();
  const { schoolyear, school } = useSchoolSchoolyear();

  const { mutateAsync } = useMutation({
    mutationFn: (planner: Planner) =>
      request(
        `/schoolyear/${schoolyear.id}/school/${school.id}/planners/${plannerId}`,
        { method: 'PATCH', body: planner },
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [schoolyear.id, school.id, PLANNER_KEY],
      });
    },
  });
  return mutateAsync;
}
